import { setToken } from '../store/slices/authSlice';

import axios from 'axios';
import { URLS } from '../config';
import { AppDispatch } from '../store';
import { RootState } from '../store';


// نوع ورودی تابع
interface LoginData {
  username: string;
  password: string;
}


export const handleLogin = async (  { username, password }: LoginData,
  dispatch: AppDispatch,
  getState: () => RootState
  ) => {
  try {
    if (!username || !password) {
      return {
        success: false,
        message: 'مقادیر وارد شده صحیح نمی‌باشد',
      };
    }
    const device_uuid = getState().device.uuid;
    const response = await axios({
      method: 'POST',
      url: URLS.LOGIN,
      data: {
        username,
        password,
        device_uuid: device_uuid, 
      },
      headers: {
        'Content-Type': 'application/json', 
      },
    });

    // بررسی وضعیت کد پاسخ از API
    if (response.status === 200) {
      if (response.data.token) {
        dispatch(setToken(response.data.token));
        // اگر لاگین موفق بود، توکن را ذخیره می‌کنیم و پیام موفقیت را ارسال می‌کنیم
        localStorage.setItem('token', response.data.token || '');
        return {
          success: true,
          message: 'ورود موفقیت‌آمیز بود.',
        };
      } else {
        // در صورتی که خطای غیرمربوط وجود داشته باشد
        if (response.data.non_field_errors && response.data.non_field_errors.length > 0) {
          return {
            success: false,
            message: response.data.non_field_errors[0], // نمایش اولین خطای غیرمربوط
          };
        }

        // در غیر این صورت پیام خطای معمولی
        return {
          success: false,
          message: response.data.message || 'خطا در ورود. لطفاً دوباره تلاش کنید.',
        };
      }
    } else if (response.status === 400) {
      // اگر پاسخ 400 (Bad Request) بود، پیغام خطا را از پاسخ گرفته و نمایش می‌دهیم
      return {
        success: false,
        message: response.data.message || 'درخواست نادرست است. لطفاً اطلاعات را بررسی کنید.',
      };
    } else {
      // سایر وضعیت‌ها
      return {
        success: false,
        message: response.data.message || 'خطا در ورود. لطفاً دوباره تلاش کنید.',
      };
    }
  } catch (error: any) {
    // در صورت وقوع خطا، پیغام خطا را می‌گیریم و به کاربر نمایش می‌دهیم
    console.error(error); // چاپ کردن خطا برای دیباگ
    if (error.response.data.non_field_errors && error.response.data.non_field_errors.length > 0) {
      return {
        success: false,
        message: error.response.data.non_field_errors[0], // نمایش اولین خطای غیرمربوط
      };
    }
    return {
      success: false,
      message: 'مشکلی در اتصال به سرور پیش آمد. لطفاً بعداً دوباره تلاش کنید.',
    };
  }
};
